import React from 'react';
import { ProductName } from "../../Styles/ProductName";

export const LicenseRequiredView = ({ nounRequiringLicense='feature' }: {nounRequiringLicense?: string}) => {
	return (
		<div>
			This&nbsp;{nounRequiringLicense}&nbsp; requires a license.
			If you are a journalist, privacy advocate, or non-profit, you may be eligible for a free license.
			If you would like to use this software to analyze your commercial website for unwanted data exfiltrations, or
			use this software in litigation against a commercial website, you will need a license.
			Contact <a target="_blank" href="mailto: inventor@datagowhere.org">the creator of <ProductName/></a>
			to learn more.
		</div>
	);
};
